import { useLayoutEffect, useState } from 'react'
import { Bubble, CloseButton } from './WelcomeOverlay.styles'

const STORAGE_KEY = 'welcome_overlay'

type WelcomeOverlayProps = {
  targetId?: string
  text?: string
}

export const WelcomeOverlay = ({
  targetId = 'floorbar',
  text = 'Выберите этаж',
}: WelcomeOverlayProps) => {
  const [visible, setVisible] = useState(false)
  const [position, setPosition] = useState({ x: 0, y: 120 })

  useLayoutEffect(() => {
    try {
      if (sessionStorage.getItem(STORAGE_KEY) === '1') return
      setVisible(true)
    } catch {
      setVisible(true)
    }
  }, [])

  useLayoutEffect(() => {
    if (!visible) return

    const updatePosition = () => {
      const target = document.getElementById(targetId)
      const rect = target?.getBoundingClientRect()

      if (!rect) {
        setPosition({
          x: window.innerWidth >= 768 ? 120 : window.innerWidth / 2,
          y: 120,
        })
        return
      }

      const edgePadding = window.innerWidth >= 768 ? 24 : 12
      const centerX = rect.left + rect.width / 2
      const clampedX = Math.min(
        window.innerWidth - edgePadding,
        Math.max(edgePadding, centerX),
      )

      setPosition({
        x: clampedX,
        y: rect.bottom + 10,
      })
    }

    updatePosition()
    window.addEventListener('resize', updatePosition)
    window.addEventListener('scroll', updatePosition, { passive: true })

    return () => {
      window.removeEventListener('resize', updatePosition)
      window.removeEventListener('scroll', updatePosition)
    }
  }, [visible, targetId])

  const handleClose = () => {
    setVisible(false)
    try {
      sessionStorage.setItem(STORAGE_KEY, '1')
    } catch {
      // ignore storage errors
    }
  }

  if (!visible) return null

  return (
    <Bubble $x={position.x} $y={position.y}>
      {text}
      <CloseButton type="button" aria-label="Закрыть подсказку" onClick={handleClose}>
        ×
      </CloseButton>
    </Bubble>
  )
}
